export default {
    list: {
        title: "Contenedores",
        subtitle: "Gestiona tus contenedores de envío",
        newContainer: "Nuevo Contenedor",
        viewMap: "Ver Mapa",
        loading: "Cargando contenedores...",
        clearFilters: "Limpiar Filtros",
        backToDashboard: "Volver al Dashboard",
        filters: {
            searchPlaceholder: "Buscar por número de contenedor, ruta...",
            statusPlaceholder: "Filtrar por estado",
            riskLevelPlaceholder: "Filtrar por nivel de riesgo",
            documentStatusPlaceholder: "Filtrar por estado de documentos",
            docStatusPlaceholder: "Estado de Documentos",
            shippingCompanyPlaceholder: "Filtrar por compañía de envío",
            commodityPlaceholder: "Filtrar por mercancía",
            originPlaceholder: "Filtrar por origen",
            portPlaceholder: "Filtrar por puerto de llegada",
            timeRangePlaceholder: "Período",
            allStatuses: "Todos los estados",
            allLevels: "Todos los niveles",
            allDocStatuses: "Todos los estados de documentos",
            allCompanies: "Todas las compañías",
            allCommodities: "Todas las mercancías",
            allOrigins: "Todos los orígenes",
            allPorts: "Todos los puertos",
            docIssuesLabel: "Problemas documentos",
            docIssuesHelper: "Mostrar solo contenedores con problemas en documentos: faltantes, no conformes o por verificar.",
            docIssuesInfoAria: "Explicar filtro Problemas documentos",
            activeAlertsLabel: "Alertas",
            activeAlertsHelper: "Mostrar solo contenedores con alertas activas: retrasos, temperatura, retención aduanera, etc.",
            activeAlertsInfoAria: "Explicar filtro Alertas",
        },
        docStatus: {
            pending: "Documentos Pendientes",
            complete: "Documentos Completos",
        },
        table: {
            title: "Contenedores",
            description: "Lista completa de contenedores",
            updating: "Actualizando...",
            headers: {
                containerNumber: "Referencia de Contenedor",
                route: "Ruta",
                progress: "Progreso",
                status: "Estado",
                documentStatus: "Documentos",
                riskLevel: "Riesgo",
                value: "Valor",
                createdAt: "Creado",
                actions: "Acciones",
                carrier: "Transportista",
                etd: "ETD",
                eta: "ETA",
                documents: "Documentos",
                docStatus: "Estado Doc",
                extraDocIssues: "Problemas Extra-Doc",
                lastUpdate: "Última Actualización",
                bookingNo: "N.° Reserva",
                blNo: "N.° B/L",
                valueUsd: "Valor (USD)",
                product: "Producto",
                qtyWeight: "Cant./Peso",
                tempC: "Temp (°C)",
                actualTd: "Salida Real",
                delayDays: "Días de Retraso",
                originPort: "Puerto Origen",
                destPort: "Puerto Dest.",
                paymentTerms: "Condiciones de Pago",
                freightTerms: "Condiciones de Flete",
            },
            view: "Ver",
            edit: "Editar",
            delete: "Eliminar",
            noContainers: {
                title: "No se encontraron contenedores",
                message: "Intenta modificar los filtros de búsqueda",
                emptyMessage: "Comienza creando tu primer contenedor",
                createFirst: "Crear el primer contenedor",
            },
        },
        charts: {
            riskLevels: "Nivel de Riesgo",
            containerStatus: "Estado de Contenedores",
            documentStatus: "Estado de Parsing de Documentos",
        },
        spreadsheet: {
            noDocuments: "Sin documentos",
            allDocsOk: "Docs OK",
            issuesInDocs: "{{count}} problemas en docs",
            noIssues: "Sin problemas",
            issueCount: "{{count}} problemas",
            comingSoon: "Próximamente",
            fewerColumns: "Menos columnas",
            moreColumns: "Más columnas",
            export: "Exportar",
            excelXlsx: "Excel (.xlsx)",
            csvFile: "CSV (.csv)",
            ofTotal: "{{current}} de {{total}}",
        },
        expandedDetails: {
            hideDetails: "Ocultar detalles",
            bookingNumber: "Número de Reserva",
            poNumber: "Número PO",
            vessel: "Buque",
            voyage: "Viaje",
            consignee: "Consignatario",
            incoterms: "Incoterms",
            transportMode: "Modo de Transporte",
            cargoType: "Tipo de Carga",
            hazardousMaterial: "Material Peligroso",
            hazardousYes: "Sí ({{hazClass}})",
            hazardousNo: "No",
            weightKg: "Peso (kg)",
            volumeCbm: "Volumen (cbm)",
            packages: "Paquetes",
            totalValue: "Valor Total",
            freightCost: "Costo de Flete",
            insurance: "Seguro",
            hsCode: "Código HS",
            progress: "Progreso",
            bookingDate: "Fecha de Reserva",
            departure: "Salida",
            created: "Creado",
            documentStatus: "Estado de Documentos",
            systemStatus: "Estado del Sistema",
            trackingProvider: "Proveedor de Tracking",
            lastTracked: "Último Tracking",
            activeAlerts: "Alertas Activas",
            alertsYes: "Sí ({{count}})",
            alertsNo: "No",
            temperature: "Temperatura",
            viewEmails: "Ver correos",
            viewDocuments: "Ver documentos",
        },
    },
    form: {
        title: "Nuevo Contenedor",
        editTitle: "Editar Contenedor",
        subtitle: "Crear un nuevo contenedor de envío",
        editSubtitle: "Editar detalles del contenedor",
        loading: "Cargando contenedor...",
        back: "Atrás",
        sections: {
            containerInfo: "Información del Contenedor",
            route: "Ruta",
            order: "Pedido",
            receiver: "Destinatario",
            value: "Valor",
            vesselInfo: "Buque y Reserva",
        },
        fields: {
            bookingNumber: "Número de Reserva",
            bookingNumberPlaceholder: "EVE2025-001234",
            containerNumber: "Número de Contenedor",
            containerNumberPlaceholder: "MAEU1234567",
            blNumber: "Conocimiento de Embarque",
            blNumberPlaceholder: "BL123456789",
            status: "Estado",
            statusPlaceholder: "Selecciona estado",
            physicalStatus: "Estado Físico",
            physicalStatusPlaceholder: "Selecciona estado físico",
            routeFrom: "Desde",
            routeFromPlaceholder: "Nueva York, EE.UU.",
            routeTo: "Hasta",
            routeToPlaceholder: "Londres, Reino Unido",
            eta: "ETA",
            shippingCompany: "Compañía de Envío",
            shippingCompanyPlaceholder: "Selecciona compañía",
            receiver: "Destinatario",
            receiverPlaceholder: "Selecciona destinatario",
            amount: "Importe",
            amountPlaceholder: "125000",
            currency: "Moneda",
            currencyPlaceholder: "Selecciona moneda",
            orderId: "ID de Pedido",
            orderIdPlaceholder: "Ingresa o selecciona ID de Pedido",
            orderIdSelectExisting: "Seleccionar de pedidos existentes",
            orderIdEnterManually: "Ingresar manualmente",
            vesselName: "Nombre del Buque",
            vesselNamePlaceholder: "Ingresa nombre del buque",
            voyageNumber: "Número de Viaje",
            voyageNumberPlaceholder: "Ingresa número de viaje",
        },
        actions: {
            cancel: "Cancelar",
            save: "Guardar Cambios",
            create: "Crear Contenedor",
        },
        errors: {
            generic: "Ocurrió un error al guardar el contenedor",
            allFieldsRequired: "Todos los campos son obligatorios",
            amountInvalid: "El importe debe ser un número mayor que 0",
            containerExists: "Ya existe un contenedor con este número",
            containerNumberRequired: "El número del contenedor es obligatorio",
            bookingNumberRequired: "El número de reserva es obligatorio",
        },
        updateSuccess: "Contenedor actualizado correctamente",
        updateError: "Error al actualizar el contenedor",
        loadError: "Error al cargar el contenedor",
        backToList: "Volver a Contenedores",
        containerNumberReadonly: "El número del contenedor no se puede modificar",
        bookingNumberReadonly: "El número de reserva no se puede modificar",
        bookingNumberHint: "Número de referencia de reserva del transportista",
        containerNumberHint: "Número de contenedor ISO (opcional - asignado por el transportista)",
        blNumberHint: "Necesario para el seguimiento del transportista",
        noReceivers: "No hay destinatarios activos disponibles. Invita un nuevo destinatario para continuar.",
        selectReceiver: "Seleccionar Destinatario",
        notesOptional: "Notas (opcional)",
        notesPlaceholder: "Añade una nota para el destinatario...",
        selectedReceiver: "Destinatario Seleccionado",
        name: "Nombre",
        email: "Email",
        country: "País",
        sendInvite: "Enviar Invitación",
    },
    detail: {
        back: "Volver a Contenedores",
        backToList: "Volver a la lista",
        loading: "Cargando detalles del contenedor...",
        notFound: {
            title: "Contenedor no encontrado",
            message: "El contenedor solicitado no existe o no tienes permiso para verlo.",
        },
        actions: {
            uploadDocuments: "Subir Documentos",
            triage: "Triage",
            edit: "Editar",
            share: "Compartir",
            archive: "Archivar",
            delete: "Eliminar",
            actions: "Acciones",
            availableActions: "Acciones Disponibles",
            comingSoon: "Próximamente",
            addNote: "Agregar Nota",
            addNoteDesc: "Agregar notas internas o para el cliente",
            evaluateDocs: "Evaluar Documentos",
            evaluateDocsDesc: "Verificación cruzada de IA para discrepancias",
            refreshTracking: "Actualizar Rastreo",
            reportIssue: "Reportar Problema",
            reportIssueDesc: "Reportar un problema con este contenedor",
            viewRisk: "Evaluación de Riesgo",
            viewRiskDesc: "Ver análisis de riesgo detallado",
            noRiskData: "Datos de Riesgo No Disponibles",
            noRiskDataDesc: "Los datos de evaluación de riesgo aún no están disponibles para este contenedor. Se calcularán cuando haya actividades o problemas que analizar.",
            noDocumentsToEvaluate: "Sin Documentos Disponibles",
            noDocumentsToEvaluateDesc: "Suba al menos 2 documentos a este contenedor para habilitar la validación cruzada.",
            needMoreDocs: "Se necesitan al menos 2 documentos",
            prepareClaim: "Preparar Reclamo",
            insuranceQuote: "Solicitar Cotización de Seguro",
            searchIssues: "Buscar Problemas Anteriores",
            makeRecurring: "Hacer Recurrente",
            duplicate: "Duplicar Contenedor",
        },
        confirmDeleteContainer: {
            title: "Eliminar Permanentemente Contenedor",
            message: "¿Estás seguro de que deseas eliminar permanentemente el contenedor {{containerNumber}}? Esta acción NO SE PUEDE deshacer.",
            warning: "ADVERTENCIA: Esta acción es IRREVERSIBLE. El contenedor y TODOS los datos relacionados serán eliminados permanentemente: documentos, eventos, problemas, notas, pedidos, correos e historial de rastreo.",
            typeDeleteLabel: "Escribe DELETE para confirmar:",
            cancel: "Cancelar",
            delete: "Eliminar Permanentemente",
            success: "El contenedor {{containerNumber}} ha sido eliminado permanentemente.",
            error: "No se pudo eliminar el contenedor. Por favor, inténtalo de nuevo.",
        },
        confirmArchiveContainer: {
            title: "Archivar Contenedor",
            message: "¿Estás seguro de que deseas archivar el contenedor {{containerNumber}}?",
            warning: "El contenedor se ocultará de la lista pero todos los datos se conservarán. Podrás restaurarlo más tarde.",
            typeArchiveLabel: "Escribe ARCHIVE para confirmar:",
            cancel: "Cancelar",
            archive: "Archivar Contenedor",
            success: "El contenedor {{containerNumber}} ha sido archivado exitosamente.",
            error: "No se pudo archivar el contenedor. Por favor, inténtalo de nuevo.",
        },
        tabs: {
            overview: "Vista General",
            info: "Información",
            documents: "Documentos",
            timeline: "Línea de Tiempo",
        },
        info: {
            containerInfo: "Información del Contenedor",
            route: "Ruta",
            shipper: "Expedidor",
            receiver: "Destinatario",
            from: "Desde",
            to: "Hasta",
            created: "Creado",
            expandMap: "Expandir mapa",
            collapseMap: "Contraer mapa",
            lastUpdate: "Última actualización",
            transportDetails: "Detalles de Transporte y Carga",
            notes: "Notas e Instrucciones",
            sections: {
                vessel: "Buque",
                container: "Contenedor",
                cargo: "Carga",
                references: "Referencias",
                primaryParties: "Partes Principales",
                otherParties: "Otras Partes (de documentos)",
                shipmentSteps: "Progreso del Envío",
                quickContacts: "Contactos Rápidos",
            },
            stakeholders: "Empresas Involucradas",
            badges: {
                hazardous: "Peligroso",
                reefer: "Reefer",
            },
            phaseTimeline: {
                title: "Estado del envío",
                phases: {
                    draft: "Borrador",
                    booked: "Reservado",
                    in_transit: "En tránsito",
                    arrived: "Llegado",
                    delivered: "Entregado",
                },
                activeDesc: {
                    draft: "Contenedor creado",
                    booked: "Reserva confirmada con el transportista",
                    inTransit: "Envío en tránsito",
                    arrived: "Llegado a destino",
                    delivered: "Entregado al destinatario",
                },
                stepsCount: "{{count}} pasos",
                by: "Por",
                subSteps: {
                    draft: "Borrador",
                    draftDesc: "Contenedor creado",
                    bookingConfirmed: "Reserva confirmada",
                    bookingConfirmedDesc: "Reserva de envío confirmada con el transportista",
                    documentsReady: "Documentos listos",
                    documentsReadyDesc: "Documentos requeridos enviados o vinculados",
                    vesselDeparted: "Buque salido",
                    vesselDepartedDesc: "Buque zarpado del puerto de origen",
                    inTransit: "En tránsito",
                    inTransitDesc: "Envío en camino al destino",
                    arrivedAtPort: "Llegada al puerto",
                    arrivedAtPortDesc: "Buque llegado al puerto de destino",
                    customsClearance: "Despacho aduanero",
                    customsClearanceDesc: "Despacho aduanero en curso o completado",
                    deliveryConfirmed: "Entrega confirmada",
                    deliveryConfirmedDesc: "Carga recibida y confirmada por el destinatario",
                },
            },
            fields: {
                status: "Estado",
                progress: "Progreso",
                riskLevel: "Nivel de Riesgo",
                documentStatus: "Estado de Documentos",
                eta: "ETA",
                value: "Valor",
                shippingCompany: "Compañía de Envío",
                country: "País",
                lastTracked: "Último rastreo",
                activeIssues: "Problemas Activos",
                vesselName: "Nombre del Buque",
                voyageNumber: "Número de Viaje",
                carrier: "Transportista",
                containerType: "Tipo de Contenedor",
                cargoType: "Tipo de Carga",
                transportMode: "Modo de Transporte",
                incoterms: "Incoterms",
                description: "Descripción",
                hsCode: "Código HS",
                weight: "Peso",
                volume: "Volumen",
                packages: "Bultos",
                bookingNumber: "N° Booking",
                blNumber: "N° BL",
                purchaseOrder: "N° Orden",
                serviceContract: "Contrato de Servicio",
                etd: "ETD",
                atd: "ATD",
                ata: "ATA",
                specialInstructions: "Instrucciones Especiales",
                customerNotes: "Notas del Cliente",
                consigneeId: "ID Destinatario",
            },
        },
        tracking: {
            lastJsonCargoUpdate: "Actualización JSONCargo",
            noJsonCargoUpdate: "Sin actualizaciones JSONCargo",
            lastEmailUpdate: "Actualización por email",
            noEmailUpdate: "Sin actualizaciones por email",
            createdFromEmail: "Creado desde email importado",
        },
        documents: {
            title: "Documentos",
            headers: {
                name: "Nombre",
                type: "Tipo",
                status: "Estado",
                uploaded: "Subido",
                actions: "Acciones",
            },
            actions: {
                view: "Ver",
                review: "Revisar",
                history: "Historial",
                download: "Descargar",
                delete: "Eliminar",
            },
            confirmDelete: {
                title: "Eliminar Documento",
                message: "¿Estás seguro de que quieres eliminar este documento? Esta acción no se puede deshacer.",
                cancel: "Cancelar",
                delete: "Eliminar",
            },
            uploadInDevelopment: "Funcionalidad de carga de documentos en desarrollo",
            uploadDocument: "Subir Documento",
            discrepancies: {
                allCongruent: {
                    title: "Todos los documentes son consistentes",
                    message:
                        "Las discrepancias se han resuelto con éxito. Todos los atributos extraídos de los documentos están ahora alineados y verificados.",
                    resetButton: "Restablecer discrepancias",
                    viewTriage: "Ver Triage",
                },
                detected: {
                    title: "Posibles discrepancias en los datos del documento",
                    message:
                        "Detectamos inconsistencias entre algunos atributos extraídos de los documentos de este contenedor. Recomendamos proceder con el triage para verificarlos y corregirlos.",
                    goToTriage: "Ir al Triage de Documentos",
                },
            },
        },
        timeline: {
            title: "Eventos de la Línea de Tiempo",
            events: {
                containerCreated: "Contenedor creado",
                statusChanged: "Estado cambiado",
                documentsUploaded: "Documentos subidos",
                progressUpdated: "Progreso actualizado",
            },
            statusChangedFrom: "Estado cambiado de",
            to: "a",
            documentsUploadedCount: "documentos subidos",
            progressUpdatedTo: "Progreso actualizado a",
        },
        notes: {
            acknowledged: "Reconocido",
            resolved: "Resuelto",
            dismissed: "Descartado",
            wontFix: "No se corregirá",
            inProgress: "En progreso",
            pendingInfo: "Pendiente de info",
            opened: "Abierto",
            actionsTab: "Acciones",
            noActionsYet: "Sin acciones aún",
            noActionsDesc: "Las evaluaciones de documentos y acciones sobre problemas aparecerán aquí",
            documentAnalysis: "Análisis de Documentos",
            allClear: "Todo correcto",
            viewResults: "Ver Resultados",
            findingsCount: "{{count}} hallazgos",
            issuesCount: "{{count}} problemas",
            edited: "editada",
        },
        evaluation: {
            stepReExtraction: "Re-ejecutando extracción\u2026",
            stepRequiredDocs: "Verificando documentos requeridos\u2026",
            stepCrossRules: "Ejecutando reglas cruzadas\u2026",
            stepAiAnalysis: "Análisis cruzado con IA\u2026",
            selectedOf: "{{selected}} de {{total}} seleccionados",
            willCheck: "Verificará: documentos faltantes \u00b7 reglas cruzadas \u00b7 análisis IA",
            requiredDocuments: "Documentos Requeridos",
            allRequiredPresent: "Todos los documentos requeridos presentes",
            missing: "faltante",
            crossCheckResults: "Resultados de Verificación Cruzada",
            crossChecksPassed: "Las {{count}} verificaciones cruzadas pasaron",
            passedAndFailed: "{{passed}} aprobadas \u00b7 {{failed}} fallidas",
            aiObservations: "Observaciones de IA",
            noDiscrepancies: "No se encontraron discrepancias",
            noData: "Sin datos",
        },
    },
    triage: {
        title: "Triage de Documentos",
        subtitle: "Contenedor",
        resolveWithAI: "Resolver con IA",
        tabs: {
            matrix: "Matriz",
            visual: "Visual",
            raw: "Datos Sin Procesar",
        },
        matrix: {
            attribute: "Atributo",
            ok: "OK",
            ko: "KO",
        },
        visual: {
            document: "Documento",
            check: "Verificar",
            ok: "OK",
        },
        raw: {
            json: "JSON",
            highlightDiscrepancies: "Resaltar discrepancias",
        },
        modal: {
            title: "Resolviendo discrepancias con IA",
            analyzing: "Analizando y corrigiendo atributos extraídos…",
            completed: "Resolución completada",
            allResolved: "Todas las discrepancias se han resuelto. Puedes cerrar esta ventana para ver los resultados actualizados.",
            close: "Cerrar",
        },
    },
    upload: {
        title: "Subir Documentos",
        subtitle: "Subir documentos para el contenedor",
        loading: "Cargando...",
        notFound: {
            title: "Contenedor no encontrado",
            message: "El contenedor solicitado no existe.",
            backToList: "Volver a la lista",
        },
        fileTooLarge: "El archivo {fileName} es demasiado grande. Máximo 10MB permitido.",
        selectAtLeastOne: "Selecciona al menos un archivo para subir",
        documentType: "Tipo de Documento",
        uploadSelected: "Subir Seleccionados",
        cancel: "Cancelar",
        confirmUpload: "Confirmar Subida",
        uploadInProgress: "Subida en progreso",
        uploadCompleted: "Subida completada",
        returnToDocuments: "Volver a Documentos",
        removeFile: "Eliminar archivo",
        selectFiles: "Seleccionar Archivos",
        selectedFiles: "Archivos Seleccionados",
        file: "archivo",
        files: "archivos",
        document: "documento",
        documents: "documentos",
        container: "Contenedor",
        uploading: "Subiendo...",
        uploadedSuccessfully: "Subido con éxito",
        documentsUploadedSuccess: "¡Documentos subidos con éxito!",
        documentsNowAvailable: "documento(s) han sido subidos y ahora están disponibles en la sección Documentos.",
        goToDocuments: "Ir a Documentos",
        confirmUploadTitle: "Confirmar Subida de Documentos",
        unknownTypeWarning:
            'Algunos documentos tienen tipo "Documento Desconocido". Esto significa que el sistema no pudo identificar automáticamente el tipo de documento.',
        unknownTypeDocuments: "Documentos con tipo Desconocido:",
        proceedAnyway: "Aún puedes proceder con la subida. Los documentos pueden clasificarse manualmente más tarde.",
        proceedWithUpload: "Proceder con la Subida",
    },
    worldMap: {
        title: "Live Tracking Hub",
        backToList: "Volver a la lista",
        updateInfo: "El sistema verifica y actualiza las posiciones de los contenedores periódicamente.",
        lastUpdate: "Última actualización",
        containerDetails: "Detalles del Contenedor",
        viewFullDetails: "Ver detalles completos",
        showContainers: "Mostrar Contenedores",
        showDetails: "Mostrar detalles",
        hideToSeeRoute: "Ocultar para ver la ruta",
        containerList: "Contenedores en el Mapa",
        containerSingular: "contenedor",
        containerPlural: "contenedores",
        filterInProgress: "En curso",
        filterDelivered: "Entregados",
        filterAll: "Todos",
    },
    receiver: {
        title: "Contenedores Recibidos",
        subtitle: "Gestiona contenedores recibidos de expedidores",
        loading: "Cargando contenedores...",
        searchPlaceholder: "Buscar por ID de contenedor, ruta o expedidor...",
        shipperPlaceholder: "Filtrar por expedidor",
        allShippers: "Todos los expedidores",
        description: "Lista completa de contenedores recibidos",
        headers: {
            containerId: "Ref. Contenedor",
            shipper: "Expedidor",
            route: "Ruta",
            shippingCompany: "Compañía de Envío",
            progress: "Progreso",
            eta: "ETA",
            status: "Estado",
            docStatus: "Estado Doc",
            riskLevel: "Nivel de Riesgo",
            value: "Valor",
            actions: "Acciones",
        },
        noContainers: {
            title: "No se encontraron contenedores",
            message: "Intenta modificar los filtros de búsqueda",
            emptyMessage: "Aún no se han recibido contenedores",
        },
        viewDetails: "Ver Detalles",
        shipper: "Expedidor",
    },
};
